import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BlockNoteContentEditor from 'components/shared/content/BlockNoteContentEditor';

/**
 * Adapter de react-final-form para el editor de contenido (BlockNote, estilo Notion:
 * menú "/", bloques arrastrables, imágenes con resize). Lo usan Noticias y T&C.
 */
function ContentEditorFieldAdapter({ input, label = '', meta, minHeight = 320 }) {
  const showError = meta.touched && Boolean(meta.error);

  return (
    <Box>
      {label && (
        <Typography variant="body2" sx={{ mb: 1 }}>
          {label}
        </Typography>
      )}
      <BlockNoteContentEditor value={input.value || ''} onChange={input.onChange} minHeight={minHeight} />
      {showError && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5, display: 'block' }}>
          {meta.error}
        </Typography>
      )}
    </Box>
  );
}

ContentEditorFieldAdapter.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }).isRequired,
  label: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool
  }).isRequired,
  minHeight: PropTypes.number
};

export default ContentEditorFieldAdapter;
